export default __webpack_public_path__ + "static/media/58.1caa25a8.svg";